define(function (require) {


    // WORK IN PROGRESS

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};

    var _ = require('underscore');
    var BaseController = require('web-agent-assets-js/BaseController');
    var lpAgent;
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var BaseApiService = require('web-agent-utils/BaseApiService');

    /* -------- Constants -------- */

    var COLLABORATION_EVENT_NAME = 'leCollaboration';
    var SECURE_FORMS_ROOT_MODEL_PATH = 'secureForms';
    var SECURE_FORMS_LIST_MODEL_PATH = 'secureForms.data.formsList';
    var SECURE_FORMS_STATE_MODEL_PATH = 'secureForms.state';
    var SECURE_FORMS_PCI_COMPLIANT_SETTINGS_STATE_MODEL_PATH = 'secureForms.pciSettings.state';
    var SECURE_FORMS_PCI_COMPLIANT_SETTINGS_DATA_MODEL_PATH = 'secureForms.pciSettings.isSitePolicyPciCompliant';
    var EVENT_TYPES = {
        SEND: 'send',
        RECEIVED: 'received',
        VIEWED: 'viewed',
        ABORTED: 'aborted',
        SUBMIT: 'submit',
        AGENT_VIEWED: 'agentViewed',
        ERROR: 'error'
    };
    var COLLABORATION_TYPES = {
        SECURE_FORM: 'leSecureForm'
    };

    var DATA_STATES = {
        FETCHING: 'fetching',
        SUCCESS: 'success',
        ERROR: 'error'
    };

    var uniqueFactorSeed = 0;

    /* -------- Class Definition -------- */

    var lpSecureFormsController = BaseController.extend(function (options) {
        this.model = options.model;
        this.secureForms = {};
        this.init();
    });

    /* -------- Static Members -------- */

    lpSecureFormsController.COLLABORATION_EVENT_NAME = COLLABORATION_EVENT_NAME;
    lpSecureFormsController.SECURE_FORMS_LIST_MODEL_PATH = SECURE_FORMS_LIST_MODEL_PATH;
    lpSecureFormsController.SECURE_FORMS_STATE_MODEL_PATH = SECURE_FORMS_STATE_MODEL_PATH;
    lpSecureFormsController.SECURE_FORMS_ROOT_MODEL_PATH = SECURE_FORMS_ROOT_MODEL_PATH;
    lpSecureFormsController.EVENT_TYPES = EVENT_TYPES;
    lpSecureFormsController.COLLABORATION_TYPES = COLLABORATION_TYPES;
    lpSecureFormsController.SECURE_FORMS_PCI_COMPILANT_SETTINGS_STATE_MODEL_PATH = SECURE_FORMS_PCI_COMPLIANT_SETTINGS_STATE_MODEL_PATH;
    lpSecureFormsController.SECURE_FORMS_PCI_COMPILANT_SETTINGS_DATA_MODEL_PATH = SECURE_FORMS_PCI_COMPLIANT_SETTINGS_DATA_MODEL_PATH;
    lpSecureFormsController.DATA_STATES = DATA_STATES;

    /* -------- Class Members -------- */

    lpSecureFormsController.prototype.applicationType = 'lpSecureFormsController';

    lpSecureFormsController.prototype.init = function () {
        // creating the secure forms service for fetching data.
        this.secureFormsApiService = new SecureFormsApiResource();

        // calling the fetch data to initialize the service data.
        this.fetchData();
        lpAgent = require('web-agent-assets-js/lpAgent');
        // attaching the collaboration event handler
        lpAgent.chat.onCollaborationEvent(this.onCollaborationEventHandler.bind(this));
    };

    /***
     * Fetching the data from the service.
     */
    lpSecureFormsController.prototype.fetchData = function () {
        this.logger.info('fetching the secure forms list');

        // starting the 'Fetch' state.
        this.model.set(SECURE_FORMS_STATE_MODEL_PATH, DATA_STATES.FETCHING);
        this.model.set(SECURE_FORMS_PCI_COMPLIANT_SETTINGS_STATE_MODEL_PATH, DATA_STATES.FETCHING);

        // fetching the data from the service.
        this.secureFormsApiService.getFormsList({
            success: this.onSecureFormsListUpdate.bind(this),
            error: this.onSecureFormsListError.bind(this)
        });

        // fetching the secure forms pci compliant state.
        this.secureFormsApiService.getPCICompliantStatus({
            success: this.onSecureFormsCompliantSuccess.bind(this),
            error: this.onSecureFormsCompliantError.bind(this)
        });

    };

    /**
     * Handle PCI Compliant check Response.
     * @param data
     */
    lpSecureFormsController.prototype.onSecureFormsCompliantSuccess = function (data) {
        var isSitePolicyPciCompliant = data && data.body && data.body.pciSettings && data.body.pciSettings.isSitePolicyPciCompliant && data.body.pciSettings.isSitePolicyPciCompliant === "true";
        this.model.set(SECURE_FORMS_PCI_COMPLIANT_SETTINGS_DATA_MODEL_PATH, isSitePolicyPciCompliant);
        this.model.set(SECURE_FORMS_PCI_COMPLIANT_SETTINGS_STATE_MODEL_PATH, DATA_STATES.SUCCESS);
    };

    /**
     * Handle PCI Compliant check Error.
     */
    lpSecureFormsController.prototype.onSecureFormsCompliantError = function () {
        this.model.set(SECURE_FORMS_PCI_COMPLIANT_SETTINGS_DATA_MODEL_PATH, false);
        this.model.set(SECURE_FORMS_PCI_COMPLIANT_SETTINGS_STATE_MODEL_PATH, DATA_STATES.ERROR);
    };


    /**
     * Handle Data updates from the secure forms service.
     * @param data
     */
    lpSecureFormsController.prototype.onSecureFormsListUpdate = function (data) {
        this.logger.info('success fetching the secure forms list');
        if (data && data.body && data.body.constructor === Array) {

            // #1: filter the 'deleted'
            var rData = _.filter(data.body, function (item) {
                return !item.deleted;
            });

            // fixing the names of the forms.
            fixEncoding(rData);

            // #: sorting alphabet by 'name'

            rData.sort(function (a, b) {
                var aString = a && a.name && a.name.toString().trim();
                var bString = b && b.name && b.name.toString().trim();

                if (aString === bString) {
                    return 0;
                }
                if (aString > bString) {
                    return 1;
                }

                return -1;
            });


            this.model.set(SECURE_FORMS_LIST_MODEL_PATH, rData, 'id');
        }
        this.model.modify(SECURE_FORMS_STATE_MODEL_PATH, DATA_STATES.SUCCESS);

        function fixEncoding(listData) {
            // http://stackoverflow.com/questions/5396560/how-do-i-convert-special-utf-8-chars-to-their-iso-8859-1-equivalent-using-javasc
            for (var i = 0; i < listData.length; i++) {
                // escape function is not found in the jshint.
                // this is the only resolution we have now.
                if (escape) {
                    listData[i].name = decodeURIComponent(escape(listData[i].name));
                }

            }
        }
    };

    /**
     * handle error from the service.
     * @param err
     */
    lpSecureFormsController.prototype.onSecureFormsListError = function (err) {
        this.logger.error('error fetching the secure forms list:' + err);
        this.logger.graph({name: 'onSecureFormsListError'});
        this.model.set(SECURE_FORMS_LIST_MODEL_PATH, [], 'id');
        this.model.set(SECURE_FORMS_STATE_MODEL_PATH, DATA_STATES.ERROR);
    };

    /**
     * Send a Secure Form Request
     * @param requestObject
     */
    lpSecureFormsController.prototype.sendSecureFormRequest = function (requestObject) {
        this.logger.info('sending a secure form request ', requestObject);

        if (!_validateRequestObject(this,requestObject)) {
            return;
        }

        var eventData = _createEventDataObject(this, EVENT_TYPES.SEND, requestObject);
        if(lpTag.WebAgent.logicController.isEngagementAsyncMessaging(requestObject.chatId)) {
            eventData.args.uniqueId = generateUniqueMessagingId(requestObject.visitorId, requestObject.chatId);
        }
        else {
            eventData.args.uniqueId = generateUniqueRealTimeId(requestObject.visitorId, requestObject.chatId);
        }

        sendCollaborationEvent(eventData, onRequestSuccess.bind(this), onRequestError.bind(this));
        this.model.modify("chats." + requestObject.chatId + ".newChatLine.lines", [eventData]);

        function onRequestSuccess(data) {
            eventData.verified = true;
            this.model.modify("chats." + requestObject.chatId + ".newChatLine.lines", [eventData]);
            if (requestObject.success) {
                requestObject.success(data);
            }
        }

        function onRequestError(data) {
            eventData.failed = true;
            eventData.errorData = data.error;
            this.model.modify("chats." + requestObject.chatId + ".newChatLine.lines", [eventData]);
            if (requestObject.error) {
                requestObject.error(data);
            }
        }
    };

    /**
     * Send collaboration "informative" event to the server
     * @param requestObject
     */
    lpSecureFormsController.prototype.reportEvent = function (requestObject) {
        this.logger.info('sending a secure form request ', requestObject);

        // Don't report the event in case of inactive chat (could be history) or if the request is not valid
        if (!lpTag.WebAgent.logicController.isActiveChat(requestObject.chatId) || !_validateRequestObject(this,requestObject)) {
            return;
        }

        var eventData = _createEventDataObject(this,requestObject.command,requestObject);
        sendCollaborationEvent(eventData, onRequestSuccess, onRequestError);

        function onRequestSuccess(data) {
            eventData.verified = true;
            if (requestObject.success) {
                requestObject.success(data);
            }

        }

        function onRequestError(data) {
            eventData.failed = true;
            eventData.errorData = data.error;
            if (requestObject.error) {
                requestObject.error(data);
            }
        }
    };


    /**
     * Retrieve the Secure Form Data from the Manager Repository
     * @param uniqueId
     * @returns {*}
     */
    lpSecureFormsController.prototype.getSecureFormData = function (uniqueId) {
        return this.secureForms[uniqueId];
    };

    /**
     *
     * @param uniqueId
     * @returns {*}
     */
    lpSecureFormsController.prototype.canViewSecureForm = function (uniqueId) {
        var thisSecureFormInstance = this.secureForms[uniqueId];
        var agentId = this.model.get('agent.id');

        if (thisSecureFormInstance) { //if the form exists
            if (thisSecureFormInstance.repId == agentId && lpTag.WebAgent.logicController.isActiveChat(thisSecureFormInstance.chatId)) {    //if it's RT active and this is the agent chatting
                return lpTag.WebAgent.logicController.hasSecureFormsViewPermission();
            } else if (!lpTag.WebAgent.logicController.isActiveChat(thisSecureFormInstance.chatId)) {                           //chat is inactive, history
                return lpTag.WebAgent.logicController.hasSecureFormsViewPermissionForHistory();
            }
        }
        return false;
    };

    lpSecureFormsController.prototype.registerFormSessionInInternalArray = function (reqObj) {
        var data = {};

        if (reqObj && reqObj.args && reqObj.args.uniqueId) {
            data.chatId = reqObj.chatId;
            data.visitorId = reqObj.visitorId;
            data.events = [];
            data.events.push(reqObj);
        }
        //todo organize this so the collab has a wrapper as well
        this.onCollaborationEventHandler(data);
    };

    /**
     * Request A Collaboration Access - OTK.
     * @param requestObject
     */
    lpSecureFormsController.prototype.requestOTK = function (requestObject) {
        var request = {
            chatId: requestObject.chatId,
            uuid: requestObject.uuid,
            success: requestObject.success,
            error: requestObject.error
        };

        if (lpTag.WebAgent.logicController.isActiveChat(requestObject.chatId)) {    //request RT data
            lpAgent.chat.requestOTKForCollaboration(request);
        } else {                                                                    //request history data
            this.secureFormsApiService.requestOTKForHistory(request);
        }
    };

    /**
     * Request A Collaboration Access - OTK for messaging history.
     * @param requestObject
     */
    lpSecureFormsController.prototype.requestMessagingOTK = function (requestObject) {
        if (lpTag.WebAgent.logicController.isActiveChat(requestObject.dialogId)) {    //request messaging data
            lpTag.WebAgent.amsController.generatePciDownloadToken(requestObject);
        } else {                                                                    //request messaging history data
            this.secureFormsApiService.requestOTKForMessagingHistory(requestObject);
        }
    };

    /**
     * Request A Collaboration Access - OTK for generate token.
     * @param requestObject
     */
    lpSecureFormsController.prototype.requestGenerateTokenOTK = function (requestObject) {
        this.secureFormsApiService.requestOTKForGenerateToken(requestObject);
    };

    /* -------- handlers -------- */

    /**
     * Handle Collaboration Request And Aggregate the data into a Unique Request Object.
     * @param data
     */
    lpSecureFormsController.prototype.onCollaborationEventHandler = function (data) {
        // TODO:(elior) - Add FormState for the object to indicate if the Form is "Valid" for display.
        var visitorId = this.model.get("chats."  + data.chatId + ".visitorInfo.visitorId");
        for (var i = 0; i < data.events.length; i++) {
            var leCollaborationEvent = data.events[i];

            if (leCollaborationEvent.subType === COLLABORATION_TYPES.SECURE_FORM) {

                if (!this.secureForms[leCollaborationEvent.args.uniqueId]) {
                    this.secureForms[leCollaborationEvent.args.uniqueId] = {
                        chatId: data.chatId,
                        visitorId: visitorId
                    };
                }

                this.secureForms[leCollaborationEvent.args.uniqueId].lastCommand = leCollaborationEvent.command;

                switch (leCollaborationEvent.command) {
                    case EVENT_TYPES.SEND:
                        // saving the OTK's.
                        this.secureForms[leCollaborationEvent.args.uniqueId].getOtk = leCollaborationEvent.args.getOtk;
                        this.secureForms[leCollaborationEvent.args.uniqueId].secureFormId = leCollaborationEvent.args.secureFormId;
                        this.secureForms[leCollaborationEvent.args.uniqueId].secureFormName = leCollaborationEvent.args.secureFormName;
                        this.secureForms[leCollaborationEvent.args.uniqueId].uniqueId = leCollaborationEvent.args.uniqueId;
                        this.secureForms[leCollaborationEvent.args.uniqueId].repId = leCollaborationEvent.args.repId;
                        this.secureForms[leCollaborationEvent.args.uniqueId].chatSessiontId = leCollaborationEvent.args.chatId;
                        this.secureForms[leCollaborationEvent.args.uniqueId].visitorId = visitorId;
                        this.secureForms[leCollaborationEvent.args.uniqueId].sequenceId = leCollaborationEvent.sequenceId;
                        break;
                    case EVENT_TYPES.ABORTED:
                        break;
                    case EVENT_TYPES.EXPIRED:
                        break;
                    case EVENT_TYPES.RECEIVED:
                        break;
                    case EVENT_TYPES.VIEWED:
                        break;
                    case EVENT_TYPES.SUBMIT:
                        this.secureForms[leCollaborationEvent.args.uniqueId].formUuid = leCollaborationEvent.args.formUuid;
                        this.secureForms[leCollaborationEvent.args.uniqueId].submitSequenceId = leCollaborationEvent.sequenceId;
                        break;
                }
            }
        }
    };

    /* -------- internal Members -------- */

    function _validateRequestObject (context,requestObject) {
        var isMessaging = lpTag.WebAgent.logicController.isEngagementAsyncMessaging(requestObject.chatId);
        if(!requestObject || !requestObject.chatId) {
            context.logger.error('Secure form request object must contain chatId');
            context.logger.graph({name: 'invalidRequestError'});
            return false;
        }

        if(!isMessaging && !requestObject.visitorId) {
            context.logger.error('Secure form request object must contain visitorId on live chat');
            context.logger.graph({name: 'invalidRequestError'});
            return false;
        }

        if (!(requestObject && requestObject.chatId && (requestObject.visitorId || requestObject.args && requestObject.args.uniqueId))) {
            context.logger.error('request object must contain chatId & visitorId.');
            context.logger.graph({name: 'invalidRequestError'});
            return false;
        }

        // validating the state of the chat id.
        var chatState = context.model.get("chats." + requestObject.chatId + ".chatInfo.state");
        if (chatState !== lpTag.WebAgent.logicController.chatStates.chatting) {
            context.logger.error('cannot send a secure form event to inactive chat.');
            context.logger.graph({name: 'inactiveChatError'});
            return false;
        }

        var mainDialog = lpTag.WebAgent.logicController.getMainDialogOfConversation(requestObject.chatId);
        if (isMessaging && mainDialog && mainDialog.dialogId !== requestObject.dialogId) {
            context.logger.error('Secure form request cannot be sent on other dialog than the main dialog');
            context.logger.graph({name: 'inactiveChatError'});
            return false;
        }

        return true;
    }

    function _createEventDataObject (context, command, requestObject) {
        var secureData = context.secureForms[requestObject && requestObject.args && requestObject.args.uniqueId];
        var dialogId = requestObject.dialogId || requestObject.chatId;
        return {
            type: COLLABORATION_EVENT_NAME,
            chatId: requestObject.chatId,
            dialogId: dialogId,
            sequence: secureData && (secureData.submitSequenceId || secureData.sequenceId),
            subType: COLLABORATION_TYPES.SECURE_FORM,
            command: command,
            text: requestObject.text,
            args: requestObject.args,
            source: 'agent',
            by: context.model.get('agent.agentName'),
            verificationId: dialogId + ":LPAgentLine" + new Date().getTime(),
            time: new Date().getTime(),
            verified: false
        };
    }

    function sendCollaborationEvent(eventData, successCallback, erroCallback) {
        eventData.success = onSuccess;
        eventData.error = onError;

        if(lpTag.WebAgent.logicController.isEngagementAsyncMessaging(eventData.chatId)) {
            if(lpTag.WebAgent.amsMessagesController.MESSAGE_STATES[eventData.command.toUpperCase()]) {
                lpTag.WebAgent.amsMessagesController.setMsgStatus(buildMessageState());
            } else {
                lpTag.WebAgent.amsController.sendPCIMessage(buildSendPciRequest());
            }
        }
        else {
            lpAgent.chat.sendCollaborationEvent(eventData);
        }

        function buildSendPciRequest() {
            return {
                title: eventData.args.secureFormName,
                formId: "" + eventData.args.secureFormId,
                conversationId: eventData.chatId,
                dialogId: eventData.dialogId,
                contentType: lpTag.AMSStatics.messageContentType.secureForm,
                invitationId: eventData.args.uniqueId,
                success: onPciSendSuccess,
                error: onError
            };
        }

        function buildMessageState() {
            return {
                conversationId: eventData.chatId,
                dialogId: eventData.dialogId,
                sequenceList: eventData.sequence,
                state: eventData.command
            };
        }

        function onPciSendSuccess(data) {
            eventData.sequenceId = data.sequence;
            eventData.sequence = data.sequence;
            eventData.id = data.sequence;
            lpTag.WebAgent.secureFormsController.registerFormSessionInInternalArray(eventData);
            onSuccess(data);
        }

        function onSuccess(data) {
            eventData.verified = true;
            if (successCallback && _.isFunction(successCallback)) {
                successCallback(data, eventData);
            }
        }

        function onError(data) {
            eventData.error = true;
            eventData.errorData = data.error;
            window.lpTag.WebAgent.secureFormsController.logger.error('error sending collaboration event:' + ' ' + data.error);
            if (erroCallback && _.isFunction(erroCallback)) {
                erroCallback(data, eventData);
            }
        }
    }


    /**
     * Generate a Unique ID for the Collaboration Request.
     * @param visitorId
     * @param formId
     * @returns {string} - a generated unique id based on the parameters.
     */
    function generateUniqueRealTimeId(visitorId, formId) {
        return visitorId + '::' + formId + '::' + Date.now() + '::' + (++uniqueFactorSeed);
    }

    /**
     * Generate a Unique ID for the Collaboration Request.
     * @param visitorId
     * @param formId
     * @returns {string} - a generated unique id based on the parameters.
     */
    function generateUniqueMessagingId(visitorId, formId) {
        return visitorId + '-' + formId + '-' + Date.now() + '-' + (++uniqueFactorSeed);
    }

    /* ***** Internal class to handle the fetching from the service ***** */
    /**
     * Secure Forms Api Resource
     * retrieve the data from the service [list of forms.]
     * @constructor
     */
    function SecureFormsApiResource() {

        var applicationType = "SecureFormsApiResource";
        var secureFormsListApiResource;
        var pciCompliantApiResource;
        var historySecureFormsListApiResource;
        var messagingHistorySecureFormsListApiResource;
        var messagingHistoryGenerateTokenApiResource;

        // TODO: investigate polling, no polling needed... only one time.

        /**
         * Fetch the Forms list from the Api Server.
         * @param reqObj
         */
        this.getFormsList = function (reqObj) {
            reqObj.callingFunction = 'getFormsList';
            reqObj.method = 'GET';
            secureFormsListApiResource.sendRequest(reqObj);
        };

        /**
         * Fetch the Compliant State from the Api Server.
         * @param reqObj
         */
        this.getPCICompliantStatus = function (reqObj) {
            reqObj.callingFunction = 'getPCICompliantStatus';
            reqObj.method = 'GET';
            pciCompliantApiResource.sendRequest(reqObj);
        };

        this.requestOTKForHistory = function (reqObj) {
            reqObj.method = 'GET';
            reqObj.data = {engId: reqObj.chatId }; //param for the query
            historySecureFormsListApiResource.sendRequest(reqObj);
        };

        this.requestOTKForMessagingHistory = function (reqObj) {
            reqObj.method = 'GET';
            reqObj.data = {convId: reqObj.dialogId }; //param for the query
            messagingHistorySecureFormsListApiResource.sendRequest(reqObj);
        };

        this.requestOTKForGenerateToken = function (reqObj) {
            reqObj.method = 'GET';
            reqObj.data = {validationId: reqObj.validationId}; //param for the query
            messagingHistoryGenerateTokenApiResource.sendRequest(reqObj);
        };

        /**
         * Initializing the Api Server EndPoints & Service Proxy.
         */
        function init() {
            // Account Config Resource - For the Secure Forms list in the Engagement window section.
            var accountConfigResource = agentLEManager.getLEUrlResolverApiResourcesService("AccountConfig");
            if (accountConfigResource && accountConfigResource.SecureForms && accountConfigResource.SecureForms.url) {
                secureFormsListApiResource = BaseApiService.createInstance({
                    domainUrl: agentLEManager.getLEUrlResolverGetUrl(accountConfigResource.SecureForms.url),
                    postmessagePath: "/postmessage",
                    serviceName: applicationType
                });
            }

            // Engagement History Resource - For the History Secure Forms lists in the widgets section.
            var historySecureFormsResource = agentLEManager.getLEUrlResolverApiResourcesService("EngagementsHistory");
            if (historySecureFormsResource && historySecureFormsResource.HistorySecureForms && historySecureFormsResource.HistorySecureForms.url) {
                historySecureFormsListApiResource = BaseApiService.createInstance({
                    domainUrl: agentLEManager.getLEUrlResolverGetUrl(historySecureFormsResource.HistorySecureForms.url),
                    postmessagePath: "/postmessage",
                    serviceName: applicationType
                });
            }

            // Messaging History Resource - For the Messaging History Secure Forms lists in the widgets section.
            var messagingHistorySecureFormsResource = agentLEManager.getLEUrlResolverApiResourcesService("MessagingEngagementsHistory");
            if (messagingHistorySecureFormsResource && messagingHistorySecureFormsResource.HistorySecureForms && messagingHistorySecureFormsResource.HistorySecureForms.url) {
                messagingHistorySecureFormsListApiResource = BaseApiService.createInstance({
                    domainUrl: agentLEManager.getLEUrlResolverGetUrl(messagingHistorySecureFormsResource.HistorySecureForms.url),
                    postmessagePath: "/postmessage",
                    serviceName: applicationType
                });
            }

            // Messaging History Resource - For the generate token for Secure Forms in the all connections table.
            if (messagingHistorySecureFormsResource && messagingHistorySecureFormsResource.GenerateToken && messagingHistorySecureFormsResource.GenerateToken.url) {
                messagingHistoryGenerateTokenApiResource = BaseApiService.createInstance({
                    domainUrl: agentLEManager.getLEUrlResolverGetUrl(messagingHistorySecureFormsResource.GenerateToken.url),
                    postmessagePath: "/postmessage",
                    serviceName: applicationType
                });
            }

            // App Server Resource - For the Compliant Status in the Root Of the Account.
            var appServerResource = agentLEManager.getLEUrlResolverApiResourcesService("AppServer");
            if (appServerResource && appServerResource.PCICompliant && appServerResource.PCICompliant.url) {
                pciCompliantApiResource = BaseApiService.createInstance({
                    domainUrl: agentLEManager.getLEUrlResolverGetUrl(appServerResource.PCICompliant.url),
                    postmessagePath: "/postmessage",
                    serviceName: applicationType
                });
            }
        }

        init();
    }


    return lpSecureFormsController;

});
